import COLORS from './colors';

const breadrumbs = {
  styleOverrides: {
    root: {
      '& .MuiBreadcrumbs-li': {
        fontSize: 14,

        '& *': {
          color: COLORS.textSecondColor,
          fontWeight: 500,
        },

        '& a': {
          color: COLORS.textSecondColor,
          transition: 'all .3s ease',
          fontWeight: 400,

          '&:hover': {
            textDecoration: 'none',
            color: COLORS.textSecondColor
          }
        }
      },
    }
  }
};

export default breadrumbs;
